import { render, staticRenderFns } from "./cpt-carousel-option.vue?vue&type=template&id=af08372c&scoped=true"
import script from "./cpt-carousel-option.vue?vue&type=script&lang=js"
export * from "./cpt-carousel-option.vue?vue&type=script&lang=js"
import style0 from "./cpt-carousel-option.vue?vue&type=style&index=0&id=af08372c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af08372c",
  null
  
)

export default component.exports